module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("l6SzY"))).then(() => parcelRequire('24TL8'));